import { createAction } from "@reduxjs/toolkit";
import { GET_MAP_LAYERS, MAP_LAYERS_RECEIVED, GetMapLayers, MapLayersReceived } from "./types";

export const getMapLayers = createAction<GetMapLayers["payload"]>(GET_MAP_LAYERS);

export const mapLayersReceived = createAction<MapLayersReceived["payload"]>(MAP_LAYERS_RECEIVED);
